import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RefundDialogData { invoiceId: number; availableRefundAmount: number; allowsPartialRefund: boolean; }
export type RefundType = 'FULL' | 'PARTIAL';
export interface RefundDialogResult { refundType: RefundType; amount?: string; }

@Component({selector: 'app-refund-invoice-dialog', templateUrl: './refund-invoice-dialog.component.html', styleUrls: ['./refund-invoice-dialog.component.scss'], standalone: false})
export class RefundInvoiceDialogComponent {
  refundType: RefundType | null = null;
  step: 'selection' | 'confirmation' = 'selection';
  selectionRequired = false;
  partialRefundUnavailable = false;
  amount = new FormControl('', [Validators.required, Validators.min(0.01), Validators.pattern(/^\d+(\.\d{1,2})?$/)]);
  constructor(public dialogRef: MatDialogRef<RefundInvoiceDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: RefundDialogData) {}

  get refundAmount(): number {
    return this.refundType === 'FULL' ? Number(this.data.availableRefundAmount) : Number(this.amount.value);
  }

  get remainingAmount(): number {
    return Math.max(0, Number(this.data.availableRefundAmount) - this.refundAmount);
  }

  get isPartialRefundSelected(): boolean {
    return this.refundType === 'PARTIAL';
  }

  selectRefundType(refundType: RefundType): void {
    this.refundType = refundType;
    this.selectionRequired = false;
  }

  review(): void {
    this.selectionRequired = !this.refundType;
    if (!this.refundType) return;

    this.partialRefundUnavailable = this.refundType === 'PARTIAL' && !this.data.allowsPartialRefund;
    if (this.partialRefundUnavailable) return;

    if (this.refundType === 'PARTIAL') {
      if (this.amount.invalid || Number(this.amount.value) > this.data.availableRefundAmount) { this.amount.setErrors({invalidRefundAmount: true}); return; }
    }
    this.step = 'confirmation';
  }

  back(): void {
    this.step = 'selection';
  }

  confirm(): void {
    if (!this.refundType) return;
    if (this.refundType === 'PARTIAL') {
      this.dialogRef.close({refundType: 'PARTIAL', amount: this.refundAmount.toFixed(2)});
      return;
    }
    this.dialogRef.close({refundType: 'FULL'});
  }
}
